import { SupplyOrderProductReceivedDetail } from './types';

/**
 * Totaux d'une réception, agrégés sur les lignes de DLC.
 *
 * Renvoie `null` — et non `0` — quand aucune ligne n'a été saisie : « pas encore compté » et « compté à
 * zéro » ne se disent pas pareil sur la fiche.
 */
export function getSupplyOrderProductReceivedTotal(productReceivedDetails: SupplyOrderProductReceivedDetail[]): {
    brokenItemsReceived: number | null;
    colisReceived: number | null;
    conditionningReceived: number | null;
    quantityReceived: number | null;
} {
    if (!productReceivedDetails.length) {
        return {
            brokenItemsReceived: null,
            colisReceived: null,
            conditionningReceived: null,
            quantityReceived: null,
        };
    }

    const totals = productReceivedDetails.reduce(
        (accumulator, { brokenItems, colis, quantity }) => ({
            brokenItemsReceived: accumulator.brokenItemsReceived + brokenItems,
            colisReceived: accumulator.colisReceived + colis,
            quantityReceived: accumulator.quantityReceived + quantity,
        }),
        { brokenItemsReceived: 0, colisReceived: 0, quantityReceived: 0 },
    );

    return { ...totals, conditionningReceived: productReceivedDetails[0].conditionning };
}

/** Deux lignes de réception ne peuvent pas porter la même DLC : elles se confondraient au rangement. */
export function areExpiryDatesUnique(productReceivedDetails: SupplyOrderProductReceivedDetail[]): boolean {
    return new Set(productReceivedDetails.map(({ expiryDate }) => expiryDate)).size === productReceivedDetails.length;
}
